var Base = require('_js/base'),
  $ = require('jquery');

function OrganizationEmployeeList() {
  this.init();
}

OrganizationEmployeeList.prototype = new Base();

OrganizationEmployeeList.prototype.init = function() {
  var self = this;
  self.$container = $('.organization-employees-container');
  self.setListItemHeight();

  $(window).on('resize', function() {
    self.setListItemHeight();
  });
};

// Will loop through the list items to find the tallest list item and
// set all other list items to this height.
OrganizationEmployeeList.prototype.setListItemHeight = function() {
  if ($(window).width() >= 641) {
    //Bigger than mobile
    var $listItems = this.$container.find('.organization-employee');
    var $height = 0;
    $listItems.each(function() {
      if ($(this).height() > $height) {
        $height = Math.ceil($(this).outerHeight());
      }
    });
    $listItems.each(function() {
      $(this).css('height', $height);
    });
  }
};

module.exports = OrganizationEmployeeList;
